import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Defence({initialData}) {


    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/defence-grade-commercial-laundry-machine",
                name: "Defence"
            }
        ]

    }


    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Mission Critical Laundry",
        description: "Purpose-engineered systems for defence establishments where equipment failure means operational compromise, delivering battlefield-grade durability, tactical textile processing, and zero-downtime reliability across India's most demanding military environments.",
        image: "/assets/images/defence-banner1.webp",
        imageWidth: 960,
        imageHeight: 804
    };

    const excellenceData = {
        subtitle: "Defence Logistics Engineering",
        title: "Operational Excellence Starts  Here",
        description1: "Supershine  is honoured to serve India's defence sector by delivering advanced commercial laundry solutions to prestigious institutions, including Military Hospitals, Command Hospitals, Armed Forces Medical College (AFMC), INHS ASVINI (Indian Navy), and several other defence establishments across the country. These projects reflect our ability to meet the stringent quality, hygiene, reliability, and operational standards required by defence organizations. Our continued association with these esteemed institutions stands as a testament to the trust placed in Supershine's engineering excellence, product quality, and dependable after-sales support.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };

    const facilityData = {
        title: "Military-Specification Engineering",
        items: [
            {
                icon: "/assets/images/defence-icon1.webp",
                heading: "Extreme Durability",
                description: "Tested and proven across Siachen glaciers (-50°C), Thar Desert (50°C), high-altitude Ladakh, coastal humidity, and field deployment scenarios destroying standard equipment."
            },
            {
                icon: "/assets/images/defence-icon2.webp",
                heading: "Tactical Protection",
                description: "Preserves camouflage patterns, ballistic protection, flame resistance, and embedded tech functionality. Every wash, mission-ready. No compromise on performance."
            },
            {
                icon: "/assets/images/defence-icon3.webp",
                heading: "Instant Deployment",
                description: "Containerized systems deploy to forward bases within 72 hours, operate on generator power, function with non-potable water sources, and require zero permanent infrastructure."
            },

            {
                icon: "/assets/images/defence-icon4.webp",
                heading: "Secure Operations",
                description: "Closed-loop water systems prevent environmental contamination, secure data logging meets defence protocols, and segregated processing maintains operational security for classified unit identification."
            },

            {
                icon: "/assets/images/defence-icon5.webp",
                heading: "Autonomous Operations",
                description: "Functions reliably with minimal supervision through predictive diagnostics, self-calibrating systems, automated chemical dosing, and fault-tolerant architecture requiring monthly maintenance only."
            },


            {
                icon: "/assets/images/defence-icon6.webp",
                heading: "Unified Operations",
                description: "Common platforms across Army, Navy, Air Force installations simplify logistics, training, spare parts inventory, and inter-service equipment sharing during joint operations. One system. All services. Seamless integration across every branch."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Deployed Across Indian Defence",
        stats: [
            {
                end: 150,
                suffix: "+",
                text: " Defence Installations <br> Operational",
            },
            {
                end: 99.2,
                suffix: "%",
                text: " System Availability <br> Rate",
            },
            {
                end: 500,
                suffix: "+",
                text: " Tactical Equipment <br> Loads Daily",
            },
            {
                prefix: "",
                end: 40,
                suffix: "%",
                text: "Water Reduction vs <br> Conventional",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Engineering Defence Solutions`,
        description: "Military laundries operate under constraints civilian facilities never face: hostile environments, tactical fabric sensitivity, water scarcity, austere deployment conditions, and operational security requirements. Our systems are purpose-built for these realities, not adapted from commercial applications.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/defence-left-image.webp",
        imageWidth: 780,
        imageHeight: 914,
        title: "Force Multiplier Through Infrastructure Reliability",
        subtitle: "The Strategic Advantage:",
        reasons: [
            "Maintain operational tempo through guaranteed uniform and equipment availability, eliminating laundry bottlenecks that delay deployments, compromise appearance standards, or reduce combat readiness levels.",
            "Protect specialized equipment investment by safely processing tactical vests, advanced combat uniforms, protective gear, and technology-integrated clothing without degrading performance characteristics or lifespan.",
            "Enable forward deployment through expeditionary systems requiring minimal infrastructure, operating on variable power and water sources, and deploying rapidly to temporary bases or conflict zones.",
            "Conserve strategic resources using closed-loop water recycling, heat recovery systems, and optimized consumption critical for desert bases, high-altitude posts, and naval vessels with limited resupply.",
            "Reduce logistics footprint through standardized platforms across services, common spare parts reducing inventory requirements, simplified training reducing personnel needs, and reduced maintenance demands freeing technical staff."
        ],
        buttonText: "Get A Base Assessment",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/institute-brand-logo1.webp", title: "Brand 1" },
            { image: "/assets/images/institute-brand-logo2.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo3.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo4.webp", title: "Brand 4" },
            { image: "/assets/images/institute-brand-logo6.webp", title: "Brand 6" },
            { image: "/assets/images/institute-brand-logo7.webp", title: "Brand 2" },
            { image: "/assets/images/institute-brand-logo8.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo9.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo10.webp", title: "Brand 3" },
            { image: "/assets/images/institute-brand-logo11.webp", title: "Brand 3" },
        ]
    };




    const businessData = {
        title: "Approved By Those <br/> Who Demand Discipline.",
        description:
            "Rugged equipment and consistent output define why defence establishments depend on Supershine for institutional laundry solutions.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“Uniform processing for our unit involves heavy fabrics, tough stains, and strict turnaround schedules. Supershine's equipment has managed all of this without compromise, and the durability under daily institutional use has been exactly what we needed. Maintenance requirements have been minimal, which matters a great deal in our setup”",
                client: "Colonel R. Sharma (Retd.), Logistics In-Charge, Defence Establishment",
            },
            {
                rating: 5,
                text:
                    "“Discipline and consistency define how we operate, and our laundry facility needed equipment that matched that standard. Since installing Supershine's systems, every batch comes out uniform in quality, which has simplified inspections considerably. The robustness of the machines under continuous institutional use has been particularly impressive.”",
                client: "Major S. Negi, Quartermaster, Cantonment Facility",
            },
            {
                rating: 5,
                text:
                    "“Scale is the defining factor for us; we process uniforms and linen for a large personnel strength daily. Supershine's high-capacity machines have made this manageable without requiring additional manpower or shifts. The equipment has run reliably through extended operational periods, which is exactly what an institution like ours needs.”",
                client: "Brigadier A. Menon (Retd.), Administration Head, Defence Base",
            },
        ],
    };





    const productData = {
        subtitle: "Recommended Products",
        title: "Military-Grade Laundry Solutions  <br> For Armed Forces",
     
    };

    const faqData = {
        title: "FAQs",
        description: "Technical answers for defence procurement and operational planning authorities.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: " How do your systems qualify for defence installation procurement?",
                answer:
                    "Our equipment meets military specifications for ruggedized construction, extreme-temperature operation (-20°C to 55°C), shock/vibration tolerance, electromagnetic compatibility, corrosion resistance for coastal installations, tactical fabric processing validation, water conservation requirements, and documented field reliability across 150+ defence installations nationwide.",
            },
            {
                question: "What differentiates tactical textile processing from commercial laundry?",
                answer:
                    "Tactical textiles require specialized handling: camouflage patterns need specific pH levels preventing dye migration, ballistic fabrics require gentle mechanical action avoiding fiber damage, flame-retardant treatments need chemistry avoiding degradation, and IR-signature fabrics demand temperature control maintaining reflective properties. Commercial processes destroy these characteristics.",
            },
            {
                question: "Can systems deploy to forward operating bases rapidly?",
                answer:
                    "Yes. Our expeditionary platforms containerize for air/rail transport, install in 48-72 hours with basic utilities, operate on generator power with voltage fluctuation tolerance, function using non-potable water with integrated filtration, and process tactical loads immediately. We've deployed to Ladakh, Northeast bases, and island territories successfully.",
            },

            {
                question: "How do you achieve water conservation in resource-constrained environments?",
                answer:
                    "Advanced systems employ multi-stage water recycling, ultra-high extraction reducing drying requirements, optimized rinse algorithms, heat recovery for water heating, and closed-loop filtration. Desert installations achieve 60% reduction versus conventional systems—critical for Rajasthan bases, forward posts, and naval applications where freshwater is strategic resource.",
            },

            {
                question: " What maintenance infrastructure do remote installations require?",
                answer:
                    "Minimal. Systems feature predictive diagnostics identifying issues before failure, modular components enabling field replacement by unit personnel with basic training, standardized parts compatible across equipment types, automated self-calibration reducing technical intervention, and quarterly preventive maintenance schedules aligned with supply chain logistics.",
            },

            {
                question: "How do you ensure operational security for classified installations?",
                answer:
                    "Closed-loop water systems prevent environmental intelligence gathering, secure data logging with access controls meets defence information protocols, segregated processing maintains unit identification security, equipment lacks external connectivity preventing cyber vulnerabilities, and installation procedures include operational security briefings for command approval.",
            },
        ],
    };

    return (
        <>
            <HealthcareBanner data={Banner} breadcrumb={bannerData.breadcrumb}/>
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product"  initialData={initialData}/>
            <HealthcareFaq data={faqData} />
        </>
    )
}









